export const PAYMENT_PLATFORM_TYPES = {
  payex: 'CREDIT_CARD',
  klarna: 'KLARNA',
  bambora: 'BAMBORA',
  dintero: 'DINTERO',
  bamboraCard: 'BAMBORA_PAYMENTCARD',
  bamboraInvoice: 'BAMBORA_INVOICE',
  vipps: 'BAMBORA_VIPPS',
  directVipps: 'VIPPS',
  payInStore: 'PAY_IN_STORE',
  invoice: 'INVOICE',
  giftCard: 'GIFT_CARD',
  zeroPayment: 'ZERO_PAYMENT',
};

export const PAYMENT_PERSON_TYPES = {
  PRIVATE: 'PRIVATE',
  COMPANY: 'COMPANY',
};

export const INVOICE_SEND_FORMATS = {
  EHF: 'EHF',
  PDF: 'PDF',
};

/**Deprecated*/
export const INVOICE_REQUEST_STATES = {
  ACCEPTED: 'ACCEPTED',
  APPROVED_WITHOUT_REQUEST: 'APPROVED_WITHOUT_REQUEST',
  AWAITING: 'AWAITING',
  NOT_FOUND: 'NOT_FOUND'
};

/**Deprecated*/
export const COMPANY_INVOICE_STATES = {
  NOT_CHECKED: 'NOT_CHECKED',
  NOT_REGISTERED: 'NOT_REGISTERED',
  REGISTERED: 'REGISTERED',
  APPROVED: 'APPROVED',
  CAN_BE_APPROVED: 'CAN_BE_APPROVED',
  REQUESTED: 'REQUESTED',
};

export const LEGAL_COMPANY_TYPES = {
  BAKERY: 'BAKERY',
  COMPANY: 'COMPANY',
  BAKERY_CUSTOMER: 'BAKERY_CUSTOMER'
};
